import { EClickableTypes } from '@/components/atoms/at-clickable/at-clickable.types';
import { EIcons } from '@/components/atoms/at-icon/icons';
import { EThemes } from '@/lib/contentstack-sdk/types';
import { IOrFloorPlanViewerProps } from './or-floorplan-viewer.types';

export const orFloorplanViewerMockData: IOrFloorPlanViewerProps = {
  heading: {
    alt_header: false,
    title: 'About this Plan',
    heading_element: { select: 'h1' },
    heading_variant: { select: 'h1' },
  },
  theme: EThemes.DARK,
  floorPlansPDF: {
    filename: '/assets/my_pdf.pdf',
    file_size: '300TB',
    url: '/assets/my_pdf.pdf',
    is_dir: false,
    content_type: 'application/pdf',
    parent_uid: '1515615',
  },
  blockAlignment: 'LEFT',
  description:
    "<ul><li>The spacious kitchen features ample counter and cabinet space, a large island for gatherings, and a walk-in pantry</li><li>Convenient pocket office provides a dedicated workspace for organization and productivity</li><li>Luxurious Owner's Retreat includes a spacious bathroom, dual walk-in closets, and easy access from the office</li><li>Plenty of private space for everyone in the family</li></ul>",

  ctaProps: {
    type: EClickableTypes.CTA,
    url: { href: '#', title: 'Get the Guidebook' },
    variant: 'PRIMARY',
    size: 'LG',
    target: 'BLANK',
    outline: true,
    label: 'Get the Guidebook',
    aria_label: 'Get the Guidebook',
    icon: [
      {
        position: { select: 'right' },
        name: { icon: 'download' as keyof EIcons },
        title: 'Get the Guidebook',
      },
    ],
  },
  blueprints: [
    {
      title: 'Main Plan',
      subtitle: 'FIRST FLOOR',
      image: {
        alt: 'Main Plan',
        src: {
          mobile: '/assets/home-plan-elevation-1.svg',
          tablet: '/assets/home-plan-elevation-1.svg',
          desktop: '/assets/home-plan-elevation-1.svg',
        },
      },
    },
    {
      title: 'Secondary Plan',
      subtitle: 'SECOND FLOOR',
      image: {
        alt: 'Secondary Plan',
        src: {
          mobile: '/assets/home-plan-elevation-2.svg',
          tablet: '/assets/home-plan-elevation-2.svg',
          desktop: '/assets/home-plan-elevation-2.svg',
        },
      },
    },
    {
      title: 'Tertiary Plan',
      subtitle: 'Basement',
      image: {
        alt: 'Tertiary Plan',
        src: {
          mobile: '/assets/home-plan-elevation-3.svg',
          tablet: '/assets/home-plan-elevation-3.svg',
          desktop: '/assets/home-plan-elevation-3.svg',
        },
      },
    },
    {
      title: 'Quarterly Plan',
      subtitle: 'Storage',
      image: {
        alt: 'Storage',
        src: {
          mobile: '/assets/home-plan-elevation-4.svg',
          tablet: '/assets/home-plan-elevation-4.svg',
          desktop: '/assets/home-plan-elevation-4.svg',
        },
      },
    },
  ],
};
